function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  stroke: "#3ABF77",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#3ABF77",
  strokeWidth: 2,
  d: "M10 5v10M5 10h10"
});

const SvgPlus = props => React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none"
}, props), _ref, _ref2);

export default SvgPlus;